import { Shield, Award, Users, TrendingUp } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: <Shield className="w-10 h-10" />,
      title: 'Trusted Reviews',
      description: 'Every casino we feature undergoes rigorous evaluation. We test platforms, verify licenses, and ensure player safety comes first.'
    },
    {
      icon: <Award className="w-10 h-10" />,
      title: 'Exclusive Deals',
      description: 'Our partnerships unlock bonuses you won\'t find elsewhere. We negotiate better terms so you get more value from every deposit.'
    },
    {
      icon: <Users className="w-10 h-10" />,
      title: 'Player-Focused',
      description: 'We understand what UK players want: fast payouts, fair games, and genuine bonuses. Our recommendations reflect real player priorities.'
    },
    {
      icon: <TrendingUp className="w-10 h-10" />,
      title: 'Always Updated',
      description: 'The casino landscape changes constantly. We keep our reviews fresh, update bonuses regularly, and track the latest industry trends.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-regal-gray">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              Why Choose Regal Play
            </h2>
            <p className="text-xl text-gray-400 leading-relaxed">
              We're not just another review site. Regal Play exists to connect UK players with casinos that deliver genuine value, exceptional service, and unforgettable gaming moments.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-regal-dark p-6 rounded-lg border border-gray-800 hover:border-regal-red transition-all"
              >
                <div className="text-regal-red mb-4">{feature.icon}</div>
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="bg-gradient-to-r from-regal-red/20 to-red-900/20 border border-regal-red/30 rounded-xl p-8 text-center">
            <p className="text-lg text-gray-200 leading-relaxed">
              Our mission is simple: help you find casinos that respect your time, your money, and your passion for gaming. We cut through marketing noise and focus on what actually matters—bonuses that pay out, games that entertain, and platforms you can trust.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

